<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('compensationManagement.TimeDelay')" name="first">
        <delayTime ref="delayTimeRef" />
      </el-tab-pane>
      <el-tab-pane :label="$t('operationTips.Lost')" name="second">
        <lostView ref="lostViewRef" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import delayTime from './component/delayTime.vue';
import lostView from './component/lostView.vue';

export default {
  name: 'TakeResponsibility',
  components: {
    delayTime,
    lostView
  },
  data() {
    return {
      activeName: 'first'
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name === 'first') {
        this.$refs.delayTimeRef.getSearch();
      } else {
        this.$refs.lostViewRef.getSearch();
      }
      console.log(tab.name, 'electronicContactLimit');
    }
  }
};
</script>

<style scoped></style>
